import { CatalogoGenerico } from '../catalogo-generico.model';

export interface IApoyo {
  tipoApoyo?: CatalogoGenerico | null;
  institucion?: CatalogoGenerico | null;
  programa?: string | null;
  pais?: CatalogoGenerico | null;
}

export class Apoyo implements IApoyo {
  constructor(
    public tipoApoyo?: CatalogoGenerico,
    public institucion?: CatalogoGenerico,
    public programa?: string | null,
    public pais?: CatalogoGenerico
  ) {
    this.tipoApoyo = this.tipoApoyo ? this.tipoApoyo : new CatalogoGenerico();
    this.institucion = this.institucion ? this.institucion : new CatalogoGenerico();
    this.programa = this.programa ? this.programa : '';
    this.pais = this.pais ? this.pais : new CatalogoGenerico();
  }
}
